import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import InvoicingForm from './forms/InvoicingForm';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import InvoicingList from "./lists/InvoicingList";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import Button from "../form/Button";
import {connect} from "src/store";
import {showModal} from "../../actions";
import {getComponentConfig} from "../../utils/components";
import InvoiceEditor from "./invoiceEditor";
import ModalEditor from "./ModalEditor";
import PrintButton from "../form/PrintButton";
import {Payments} from "./paymentEditor";
import Confirm from "../form/Confirm";
import Invoice from "./OperationList/Elements/Invoice";
import Payment from "./OperationList/Elements/Payment";
import get from "../../utils/get";
import set from "../../utils/set";
import {isEqual} from "lodash-es";
import context from "./Context/context";

class InvoicingEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            message: null,
            messageType: null,
            createInvoice: {
                payment: {
                    serviceprovider_type: this.props.values.payment
                },
                invoice: {
                    comment: this.props.values.comment,
                },
                deadline: this.props.values.deadline,
                transactiondate: this.props.values.transactiondate,
                accountdate: this.props.values.accountdate,
            },
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(prevProps.values, this.props.values)) {
            this.setState({
                createInvoice: {
                    payment: {
                        serviceprovider_type: this.props.values.payment
                    },
                    invoice: {
                        comment: this.props.values.comment,
                    },
                    deadline: this.props.values.deadline,
                    transactiondate: this.props.values.transactiondate,
                    accountdate: this.props.values.accountdate,
                }
            });
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (field) => {
        const props = this.props.getFieldProps(field);
        if (this.props.values[this.props.componentConfig.idfield] && parseInt(this.props.values.state || '0') > 0) {
            props.disabled = props.disabled || true;
        }
        return props;
    }


    componentDidMount() {
        this.componentConfigRequest = getComponentConfig('InvoicingItem');
        this.componentConfigRequest.then((componentConfig) => {
            const invoicing_types = componentConfig.objects.map(item => { return { component: item }; });
            this.setState({ invoicing_types: invoicing_types });
        });
    }

    createInvoice = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.createInvoice',
                id: this.props.values[this.props.componentConfig.idfield],
                ...this.state.createInvoice,
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    deleteForm = async () => {
        await this.props.deleteForm();
        this.editor && this.editor.hide();
    }

    getValue = (name) => {
        return get(this.state.createInvoice, name, undefined);
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        props.disabled = this.props.disabled || props.disabled;
        return props;
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        const state = parseInt(this.props.values.state || '0');
        return (
            <Fragment>
                <Modal
                    state={this.state.message !== null ? "on" : "off"}
                    theme={this.state.messageType}
                    size={"large"}
                    header={"Mentés"}
                    buttons={[
                        {
                            text: 'Ok',
                            onClose: true,
                            onClick: async () => {
                                this.setState({message: null, messageType: null});
                            }
                        }
                    ]}
                >
                    {this.state.message}
                </Modal>
                <List
                    {...this.props}
                    theme="default"
                    header="Kimenő számlák"
                    footer={[
                        <Button
                            key="0"
                            color="default"
                            disabled={this.props.isLoading}
                            onClick={this.pristineForm}>
                            Új
                        </Button>
                    ]}
                >
                    <InvoicingList
                        ref={(el) => this.list = el}
                        {...this.props}
                        loadForm={this.loadForm}
                        filter={[{field: "seller", value: this.props.context.partner.partner_id}]}
                    />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Kimenő számla"
                    footer={<Fragment>
                        {this.props.values[this.props.componentConfig.idfield] && state === 0 && <Confirm
                            disabled={this.props.isLoading || this.props.dirty}
                            color="success"
                            className="pull-right"
                            acceptButton="Számlázás"
                            header="Számlázás"
                            size="large"
                            body={<Fragment>
                                <Invoice
                                    props={{
                                        values: {...this.state.createInvoice, seller: this.props.context.partner},
                                        getProps: (name) => this.getProps(name),
                                        getValue: (name) => this.getValue(name),
                                        setFieldValue: (field, value) => {
                                            let createInvoice = this.state.createInvoice;
                                            set(createInvoice, field, value);
                                            this.setState({
                                                createInvoice
                                            });
                                        }
                                    }}
                                    default="seller"
                                />
                                <div className="row">
                                    <Payment
                                        props={{
                                            values: this.state.createInvoice,
                                            getFieldProps: this.getProps,
                                            getProps: this.getProps,
                                            getValue: this.getValue,
                                            setFieldValue: (field, value) => {
                                                let createInvoice = this.state.createInvoice;
                                                set(createInvoice, field, value);
                                                this.setState({
                                                    createInvoice
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </Fragment>}
                            acceptAble={!!this.state.createInvoice.payment.serviceprovider_type}
                            onAccept={this.createInvoice}
                        >
                            Számlázás
                        </Confirm>}
                        <Button
                            disabled={this.props.isLoading || !this.props.dirty}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                        {this.props.values[this.props.componentConfig.idfield] && state === 30 && <PrintButton
                            {...this.props}
                            type="pdf"
                            className="pull-right"
                            icon={{lib: "fas", name: "download"}}
                            color="default"
                            disabled={this.props.isLoading || this.props.dirty}
                        >
                            Letöltés
                        </PrintButton>}
                        {this.props.values[this.props.componentConfig.idfield] && (state === 30 || state === 0) && <Button
                            color="danger"
                            className="pull-left"
                            onClick={this.deleteForm}
                        >
                            Törlés
                        </Button>}
                    </Fragment>}
                >
                    <InvoicingForm
                        ref={(form) => this.form = form}
                        {...this.props}
                        invoicing_types={this.state.invoicing_types}
                        getFieldProps={this.getFieldProps}
                    />
                </Editor>
                <Other>
                    {this.props.values[this.props.componentConfig.idfield] && state > 0 &&
                    <Fragment>
                        <Payments
                            {...this.props}
                            collapsed={state === 0}
                            disable={state === 0}
                        />
                        <InvoiceEditor
                            editorContext="InvoicingInvoiceEditor"
                            gridid="InvoicingInvoiceList"
                            pageSize={0}
                            listFilter={[
                                {
                                    field: "component",
                                    value: this.props.componentConfig.componentname
                                },{
                                    field: "component_id",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }
                            ]}
                            editor={ModalEditor}
                            selection={null}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                    </Fragment>}
                </Other>
            </Fragment>
        );
    }
}

export default context(connect((state) => {
    return {
        context: state.app.context,
        user: state.app.user
    };
},{showModal})(createEditor({
    componentName: "Invoicing",
    editor: "Invoicing",
    WrappedComponent: InvoicingEditor,
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
})), {needle: ["till"]});
